<template>
  <div
    v-if="isSidebarLoading"
    class="p-20 flex justify-center"
  >
    <BaseSpinner />
  </div>
  <div v-else>
    <component
      :is="getPageBuilderWidgetByType(widget.type)"
      v-for="widget in sidebarWidgets"
      :key="widget.id"
      :value="widget"
    />
  </div>
</template>

<script>
import useSidebar from '@/composables/useSidebar'
import usePageBuilderWidgets from '@/composables/usePageBuilderWidgets'

export default {
  setup() {
    const { isSidebarLoading, sidebarWidgets, fetchSidebar } = useSidebar()
    const { getPageBuilderWidgetByType } = usePageBuilderWidgets()

    return {
      isSidebarLoading,
      sidebarWidgets,
      getPageBuilderWidgetByType,
      fetchSidebar,
    }
  },
  created() {
    this.fetchSidebar()
  },
}
</script>
